// Whitelist of event urlPaths
const events = [
  'test-ride'
].join('|');

const MYFF = '/MyFF'

const PATHS = {
  US_BASE: '/us',
  CN_BASE: '/cn',
  MY_FF: MYFF,
  // Account info page
  ACCOUNT: '/account',
  MY_ACCOUNT: `${MYFF}/account`,
  MY_RESERVATIONS: `${MYFF}/preorders`,
  MY_EVENTS: `${MYFF}/events`,
  MY_REFERRALS: `${MYFF}/referrals`,
  MY_FF_POINTS: `${MYFF}/points`,
  // FX paths
  MY_FX_REFERRALS: `${MYFF}/fx-referrals`,
  MY_FX_POINTS: `${MYFF}/fx-points`,
  MY_DESIGNS: `${MYFF}/designs`,
  VEHICLE_REGISTRATION: `${MYFF}/vehicle-registration`,
  DELIVERY_LOCATION: `${MYFF}/delivery-location`,
  BILLING: `${MYFF}/billing`,
  // Login / sign up page
  LOGIN: '/account/login',
  OAUTH_LOGIN: '/account/oauth/login',
  OAUTH_REGISTER: '/account/oauth/register',
  OAUTH_LOGOUT: '/account/oauth/logout',
  LOGOUT: '/account/logout',
  // Welcome, successful login
  SUCCESS: '/account/success',
  // Forgot password page
  FORGOT_PASS: '/account/forgot-password',
  // Reset password page
  RESET_PASS: '/account/reset-password/:key',

  // Order
  ORDERS: `${MYFF}/orders`,

  // Reserve
  RESERVE: '/preorder',
  // Reservation detailed view
  RESERVE_DETAILS: `${MYFF}/preorders/details/:confNum`,
  RESERVE_DETAILS_BASE: `${MYFF}/preorders/details`,
  ORDER_DETAILS: `${MYFF}/orders/details/:confNum`,
  ORDER_DETAILS_BASE: `${MYFF}/orders/details`,
  DESIGN_DETAILS: `${MYFF}/designs/details/:confNum`,
  DESIGN_DETAILS_BASE: `${MYFF}/designs/details/`,
  // My Referrals
  REFERRAL: '/referral/:referralCode',
  // FX Referrals
  FX_REFERRAL: '/fx-referral/:referralCode',
  DESIGN: '/design',
  CONFIGURATOR: '/configurator',
  NEW_CONFIGURATOR: '/design',
  PAYMENT: '/payment',
  PAYMENT_SUCCESS: '/payment/success',
  ERROR: '/error',

  // EcoSystem Product
  ECOSYSTEM_PRODUCT_PAGE: `/ecosystem-product`,
  MY_ECOSYSTEM_PRODUCT: `${MYFF}/ecosystem-product`,
  ECOSYSTEM_PRODUCT_DETAILS: `${MYFF}/ecosystem-product/details/:itemId`,
  ECOSYSTEM_PRODUCT_PREORDER: '/ecosystem-product-preorder',
  APP_ECOSYSTEM_PRODUCT_DETAILS: `/h5/ecosystem-product-details/:itemId`,
  APP_ECOSYSTEM_PRODUCT_PREORDER: `/h5/ecosystem-product-preorder`,

  // User Resouces
  MY_USER_RESOURCES: `${MYFF}/user-resources`,

  // Disconnect Remote Vehicle Access
  DISCONNECT_REMOTE_VEHICLE_ACCESS: '/disconnect-remote-vehicle-access',

  // Events
  BASE_EVENT: '/event',
  // Routes include whitelist; Others are for navigation (history.push())
  LANDING_EVENT_ROUTE: `/event/:eventName(${events})`,
  SCHEDULE_EVENT_ROUTE: `/event/:eventName(${events})/schedule`,
  CONFIRM_EVENT_ROUTE: `/event/:eventName(${events})/confirm`,
  RESCHEDULE_EVENT_ROUTE: `/event/:eventName(${events})/reschedule`,
  DEMO_DRIVE_ROUTE: `/event/demo-drive`,
  DEMO_DRIVE_ROUTE_SUCCESS: `/event/demo-drive/success`,
  LANDING_EVENT: '/event/:eventName',
  SCHEDULE_EVENT: '/event/:eventName/schedule',
  CONFIRM_EVENT: '/event/:eventName/confirm',
  RESCHEDULE_EVENT: '/event/:eventName/reschedule',

  FF91_PRODUCT_PAGE: '/ff-91/',
  FF91_PREORDER: '/ff-91',
  APP_FF91_PREORDER: '/h5/ff-91-preorder/',
  FF91_FUTURIST_PREORDER: '/ff-91-Futurist',
  APP_FF91_FUTURIST_PREORDER: '/h5/ff-91-Futurist-preorder/',
  
  // FX paths
  FX_HOME: '/fx',
  
  // FX Simple Preorder paths
  FX_SIMPLE_PREORDER: '/fx',
  FX_SIMPLE_PREORDER_SUPER_ONE: '/fx-super-one',
  FX_PREORDER_DETAILS: `${MYFF}/fx-preorders/details/:orderNumber`,
  FX_PREORDER_DETAILS_BASE: `${MYFF}/fx-preorders/details`,
  APP_FX_SIMPLE_PREORDER: '/h5/fx-preorder/',
  APP_FX_PREORDER_DETAILS: '/h5/fx-preorder-details/:orderNumber',

  // FF Robot Preorder paths
  FF_ROBOT_PREORDER: '/robotics',
  FF_ROBOT_PREORDER_LEARN_MORE: '/us/robotics/preorder-learn-more/',
  FF_ROBOT_PREORDER_AGREEMENT: '/us/robotics/preorder-agreement/',
  FF_ROBOT_REFERRAL_PROGRAM_LEARN_MORE: '/us/referral-learn-more/',
  APP_FF_ROBOT_PREORDER_LEARN_MORE: '/h5/ff-robotics-preorder-learn-more/',
  APP_FF_ROBOT_PREORDER_AGREEMENT: '/us/app/robotics/preorder-agreement/',
  APP_FF_ROBOT_REFERRAL_PROGRAM_LEARN_MORE: '/h5/ff-robotics-referral-learn-more/',
  APP_FF_ROBOT_PREORDER: '/h5/preorder/robotics',
  APP_FF_ROBOT_PREORDER_DETAILS: '/h5/ff-robotics-preorder-details/:orderNumber',

  // FX Early Access Preorder paths
  FX_EARLY_ACCESS_PREORDER: '/fx-early-access',
  APP_FX_EARLY_ACCESS_PREORDER: '/h5/fx-early-access-preorder/',

  // FX Fleet paths
  FX_FLEET: '/fx-fleet',
  FX_FLEET_LOGIN: '/fx-fleet/login',
  FX_FLEET_REGISTER: '/fx-fleet/register',
  FX_FLEET_COMPANY_INFO: '/fx-fleet/company-info',
  FX_FLEET_DASHBOARD: '/fx-fleet/account',
  FX_FLEET_PREORDER: '/fx-fleet/preorder',
  FX_FLEET_DASHBOARD_QUOTA_MANAGEMENT: '/fx-fleet/account/quota-management',
  FX_FLEET_DASHBOARD_REFERRAL_RECORD: '/fx-fleet/account/referral-record',
  FX_FLEET_DASHBOARD_CREDITS: '/fx-fleet/account/credits',
  FX_FLEET_DASHBOARD_ORDERS: '/fx-fleet/account/orders',
  FX_FLEET_ORDER_DETAILS: '/fx-fleet/account/orders/:orderNumber',
  FX_FLEET_ORDER_DETAILS_BASE: '/fx-fleet/account/orders',
  FX_FLEET_DASHBOARD_SETTINGS: '/fx-fleet/account/settings',
  FX_FLEET_PREORDER_AGREEMENT: '/us/fx-preorder-agreement-business/',

  // FF Robot Business paths
  FF_ROBOT_BUSINESS: '/robotics-business',
  FF_ROBOT_BUSINESS_LOGIN: '/robotics-business/login',
  FF_ROBOT_BUSINESS_REGISTER: '/robotics-business/register',
  FF_ROBOT_BUSINESS_COMPANY_INFO: '/robotics-business/company-info',
  FF_ROBOT_BUSINESS_DASHBOARD: '/robotics-business/account',
  FF_ROBOT_BUSINESS_PREORDER: '/robotics-business/preorder',
  FF_ROBOT_BUSINESS_DASHBOARD_QUOTA_MANAGEMENT: '/robotics-business/account/quota-management',
  FF_ROBOT_BUSINESS_DASHBOARD_REFERRAL_RECORD: '/robotics-business/account/ff_ref',
  FF_ROBOT_BUSINESS_DASHBOARD_CREDITS: '/robotics-business/account/credits',
  FF_ROBOT_BUSINESS_DASHBOARD_ORDERS: '/robotics-business/account/orders',
  FF_ROBOT_BUSINESS_ORDER_DETAILS: '/robotics-business/account/orders/:orderNumber',
  FF_ROBOT_BUSINESS_ORDER_DETAILS_BASE: '/robotics-business/account/orders',
  FF_ROBOT_BUSINESS_DASHBOARD_SETTINGS: '/robotics-business/account/settings',
  FF_ROBOT_BUSINESS_PREORDER_AGREEMENT: '/us/robotics/preorder-agreement',

  toCN: '/cn/MyFF',
  toUS: '/us/MyFF',
  PRIVACY: '/us/privacy-policy',
  TERMS_OF_USE: '/us/terms-of-use',
  DEMO_DRIVE_WAIVER: 'https://genesis-cdn.ff.com/assets/pages/demo-drive/V.2+FF+Release+of+Liability+and+Waiver+Rights+July+2023.pdf',
  REZ_AGREEMENT: '/us/preorder-agreement',
  FX_REZ_AGREEMENT: '/us/fx-preorder-agreement',
  MAIL_PRODUCT: 'mailto:product@ff.com',
  REFERRAL_PROGRAM_TERMS: '/us/employee-referral-program-terms',
  REFERRAL_PROGRAM_LEARN_MORE: '/us/referral-learn-more/',
  REFERRAL_PROGRAM_AGREEMENT: '/us/referral-agreement/',
  FX_REFERRAL_PROGRAM_LEARN_MORE: '/us/fx-referral-learn-more/',
  ECOPRODUCT_AGREEMENT: '/us/aiHypercar-preorder-agreement',

  VERIFY_EMAIL: '/verify-email/:email',
  APP_RESERVE: '/h5/reserve',
  APP_LEARN_MORE: '/h5/reserve/learn-more',
  APP_USER_INFO: '/h5/reserve/user-info',
  APP_USER_AGREEMENT: '/h5/reserve/user-agreement',
  APP_PREORDER_AGREEMENT: '/h5/reserve/preorder-agreement',
  APP_FX_PREORDER_AGREEMENT: '/h5/fx-preorder-agreement',
  APP_ECOPRODUCT_AGREEMENT: '/h5/aiHypercar-preorder-agreement',
  APP_BILLING_INFO: '/h5/reserve/billing-info',
  APP_DELIVERY_CANCELLATION: '/h5/reserve/delivery-cancellation',

  APP_ORDER_DETAILS: '/h5/order-details/:confNum',
  APP_DESIGN_DETAILS: '/h5/design-details/:confNum',
  APP_FF91_STANDARD_PREORDER: '/us/h5/ff-91-preorder',

  // FF 91 Configurator
  FF91_CONFIGURATOR: '/us/design/2022/FF91/model',
  FF91_CONFIGURATOR_OPTIONS: '/us/design/2022/FF91/options',
  FF91_CONFIGURATOR_SUMMARY: '/us/design/2022/FF91/summary',
  FF91_STANDARD_PREORDER: '/us/preorder/ff-91',

  FF91_FUTURIST_PRODUCT: '/us/product/ff-91-Futurist/',
  FF91_FUTURIST_ALLIANCE_PRODUCT: '/us/product/ff-91-Alliance/',

  // UAE
  PRIVACY_AE_EN: '/ae_en/privacy-policy',
  PRIVACY_AE_AR: '/ae_ar/privacy-policy',
  TERMS_OF_USE_AE_EN: '/ae_en/terms-of-use',
  TERMS_OF_USE_AE_AR: '/ae_ar/terms-of-use',
  FX_PREORDER_AGREEMENT_AE_EN: '/ae_en/fx-preorder-agreement',
  FX_PREORDER_AGREEMENT_AE_AR: '/ae_ar/fx-preorder-agreement',
};

PATHS.FF91_FUTURIST_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.RESERVE}${PATHS.FF91_FUTURIST_PREORDER}`;
PATHS.APP_FF91_FUTURIST_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.APP_FF91_FUTURIST_PREORDER}`;

PATHS.FX_SIMPLE_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.RESERVE}${PATHS.FX_SIMPLE_PREORDER}`;
PATHS.APP_FX_SIMPLE_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.APP_FX_SIMPLE_PREORDER}`;

PATHS.FX_EARLY_ACCESS_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.RESERVE}${PATHS.FX_EARLY_ACCESS_PREORDER}`;
PATHS.APP_FX_EARLY_ACCESS_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.APP_FX_EARLY_ACCESS_PREORDER}`;

PATHS.FF_ROBOT_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.RESERVE}${PATHS.FF_ROBOT_PREORDER}`;
PATHS.APP_FF_ROBOT_PREORDER_FULL = `${PATHS.US_BASE}${PATHS.APP_FF_ROBOT_PREORDER}`;

export default PATHS;
